'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contants = require('./contants');

var RGX_WHITESPACE = /\s/;
var RGX_WORD = /\w/;

function tokenizer(input) {
  var cursor = 0;
  var tokens = [];

  while (cursor < input.length) {
    var char = input[cursor];

    // Note: order checks by compute expense

    if (char === '>') {
      tokens.push({ type: _contants.COMBINATOR_TOKEN, value: _contants.CHILD_COMBINATOR_VALUE });
      cursor++;
      continue;
    }

    if (RGX_WHITESPACE.test(char)) {
      cursor++;
      continue;
    }

    if (RGX_WORD.test(char)) {
      var value = '';
      while (char && RGX_WORD.test(char)) {
        value += char;
        char = input[++cursor];
      }
      tokens.push({ type: _contants.ELEMENT_TOKEN, value: value });
      continue;
    }

    console.error('Should not have reached');
    cursor++;
  }

  tokens = tokens.reduce(function (accum, token, i) {
    accum.push(token);
    if (token.type === _contants.ELEMENT_TOKEN && tokens[i + 1] && tokens[i + 1].type === _contants.ELEMENT_TOKEN) {
      accum.push({
        type: _contants.COMBINATOR_TOKEN,
        value: _contants.DESCENDANT_COMBINATOR_VALUE
      });
    }
    return accum;
  }, []);

  return tokens;
}

exports.default = tokenizer;